// extracted by mini-css-extract-plugin
module.exports = {"gradeTag":"VehicleExteriorGradeTag_gradeTag__sJgwN","gradeText":"VehicleExteriorGradeTag_gradeText__3i0yX","noBackground":"VehicleExteriorGradeTag_noBackground__WkfFC"};